<div class="container-fluid d-flex flex-column justify-content-center align-items-center vh-100 text-center">
  <div class="mb-4">
    <i class="bi bi-wifi-off display-1 text-muted"></i>
  </div>
  <h1 class="display-4 fw-bold mb-3">Errore di connessione</h1>
  @if (!navigator.onLine) {
    <p class="lead text-muted mb-4">
      Sembra che tu non sia connesso a internet.<br>
      Controlla la tua connessione e riprova.
    </p>
  } @else {
    <p class="lead text-muted mb-4">
      Si è verificato un errore al server<br>
      Riprova più tardi.
    </p>
  }
  <button class="btn btn-primary btn-lg px-4" (click)="reloadPage()">
    <i class="bi bi-arrow-clockwise me-2"></i>Riprova
  </button>
</div>
